export const firstName = {
  id: "firstName",
  label: "First Name",
  placeholder: "{{first name}}",
};
